// extracted by mini-css-extract-plugin
export var container = "_5r-0";
export var error = "_5r-9";
export var label = "_5r-5";
export var light = "_5r-6";
export var md = "_5r-3";
export var sm = "_5r-2";
export var thin = "_5r-8";
export var thinBold = "_5r-7";
export var vertical = "_5r-4";
export var xs = "_5r-1";